export default __webpack_public_path__ + "static/media/DIY01.d1dc65dd.JPG";